import { FC, useState, useEffect } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import Login from "./modules/Account/AccountLogin/index";
import ForgotPassword from "./modules/Account/AccountActions/forgot-password/index";
import ChangePassword from "./modules/Account/AccountActions/forgot-password/change-password";
import env from "./config/env";
import http from "./services/http";
import { getSecondarySessionKey, getSessionKey } from "./utils/SsoSession";
import PortalSelectionPage from "./modules/PortalSelection/index";
import LogoutPage from "./modules/Logout";
import MyProfilePage from "./modules/MyProfile";
import { Layout } from "./components";
import ClientService from "./modules/Admin/ClientManagement/index";
import ClientStore from "../src/modules/Admin/ClientManagement/store";
import ExternalUserManagementPage from "./modules/Admin/ExternalUserManagement/Index";

import { MessageResultState } from "./types/general-types";
import LoginAsUserPage from "./modules/Admin/LoginAsUser/Index";
import WithoutLayout from "./components/Layout/WithoutLayout";

interface IState {
  token: string | null;
  isAuthorized: undefined | boolean;
}

const { API_BASE_URL } = env;

const Routers: FC = (props: any) => {
  const { location } = props;
  http.defaults.baseURL = API_BASE_URL;
  const [state] = useState<IState>({
    token: getSecondarySessionKey()
      ? getSecondarySessionKey()
      : getSessionKey(),
    isAuthorized: getSessionKey() || getSecondarySessionKey() ? true : false,
  });

  useEffect(() => {
    if (state.isAuthorized === false) {
      if (
        location.pathname !== "/" &&
        location.pathname !== "/login" &&
        location.pathname !== "/forgot-password" &&
        location.pathname !== "/change-password"
      ) {
        window.location.href = "login";
      }
    } else {
      const queryParams = new URLSearchParams(window.location.search);
      const clientId = queryParams.get("clientId");
      const returnUrl = queryParams.get("returnUrl");
      if (clientId) {
        new ClientStore().getById(clientId).then((res) => {
          if (res.state === MessageResultState.SUCCESS) {
            window.location.href =
              res.result.redirectUri +
              "?sessionKey=" +
              state.token +
              (returnUrl ? "&returnUrl=" + returnUrl : "");
          }
        });
      } else {
        if (location.pathname === "/" || location.pathname === "/login") {
          window.location.href = "portal-selection";
        }
      }
    }
  }, [state]);

  return (
    <>
      {/* Dışarıdaki <button> sarmalayıcısını kaldırın */}
      {/* <div>
        <LanguageSelection />
      </div> */}
      <Switch>
        <Route
          path={"/portal-selection"}
          component={() => <Layout component={PortalSelectionPage} />}
        />
        <Route
          exact
          path="/client-page"
          component={() => <Layout component={ClientService} />}
        />
        <Route
          exact
          path="/external-user-page"
          component={() => <Layout component={ExternalUserManagementPage} />}
        />
        <Route
          exact
          path="/login-as-user"
          component={() => <Layout component={LoginAsUserPage} />}
        />
        <Route
          exact
          path="/"
          component={() => <WithoutLayout component={Login} />}
        />
        <Route
          exact
          path="/login"
          component={() => <WithoutLayout component={Login} />}
        />
        <Route
          exact
          path="/forgot-password"
          component={() => <WithoutLayout component={ForgotPassword} />}
        />
        <Route
          exact
          path="/change-password"
          component={() => <WithoutLayout component={ChangePassword} />}
        />

        <Route
          exact
          path="/logout"
          component={() => <WithoutLayout component={LogoutPage} />}
        />
        <Route
          exact
          path="/my-profile"
          component={() => <Layout component={MyProfilePage} />}
        />
      </Switch>
    </>
  );
};

export default withRouter(Routers);
